module.exports = __webpack_public_path__ + "static/media/declaration-sinistre-login.5c162f9c.svg";